import { actions } from './actions'

const initialState = {
    subscriptionPlans: [],
    subPaymentMethods: [],
    gettingSubPaymentMethods: false,
    gettingSubcriptionPlanDetails: false,
    subscriptionPlanDetails: null,
    newSubscriptionInProgress: false,
    reactivateSubscriptionInProgress: false,
    subscription: null,
    updateSubPaymentInProgress: false,
    selectedSubscriptionCard: null,
    subscriptionRenewalsList: [],
    getSubscriptionRenewalsInProgress: false,
    subscriptionPromoProducts: [],
    gettingSubscriptionPromoProducts: false,
    cancelSubscriptionInProgress: false,
    cancelSubscriptionResponse: null,
    failedSubscriptionPayment: false,
    subscriptionsActionResponse: null,
    showFailedSubscriptionPaymentModal: false,
    showDeleteSubscriptionCardModal: false,
}

const subscription = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actions.GET_SUBSCRIPTION_PLAN_DETAILS: {
            return { ...state, gettingSubcriptionPlanDetails: true }
        }

        case actions.GET_SUBSCRIPTION_PAYMENT_METHODS: {
            return { ...state, gettingSubPaymentMethods: true }
        }

        case actions.GET_SUBSCRIPTION_PAYMENT_METHODS_SUCCESS: {
            return {
                ...state,
                gettingSubPaymentMethods: false,
                subPaymentMethods: payload,
            }
        }

        case actions.GET_SUBSCRIPTION_PAYMENT_METHODS_FAILED: {
            return {
                ...state,
                gettingSubPaymentMethods: false,
            }
        }

        case actions.GET_SUBSCRIPTION_PLAN_DETAILS_SUCCESS: {
            return {
                ...state,
                subscriptionPlanDetails: payload,
                selectedSubscriptionCard: null,
                gettingSubcriptionPlanDetails: false,
            }
        }

        case actions.GET_SUBSCRIPTION_PLAN_DETAILS_FAILED: {
            return {
                ...state,
                gettingSubcriptionPlanDetails: false,
            }
        }

        case actions.SIGNUP_NEW_SUBSCRIPTION: {
            return {
                ...state,
                newSubscriptionInProgress: true,
            }
        }

        case actions.SIGNUP_NEW_SUBSCRIPTION_SUCCESS: {
            return {
                ...state,
                newSubscriptionInProgress: false,
                subscription: payload,
                subscriptionsActionResponse: payload,
            }
        }

        case actions.SIGNUP_NEW_SUBSCRIPTION_FAILED: {
            return {
                ...state,
                newSubscriptionInProgress: false,
                subscriptionsActionResponse: payload,
            }
        }

        case actions.UPDATE_SUBSCRIPTION_PAYMENT: {
            return {
                ...state,
                updateSubPaymentInProgress: true,
            }
        }

        case actions.UPDATE_SUBSCRIPTION_PAYMENT_SUCCESS: {
            return {
                ...state,
                updateSubPaymentInProgress: false,
                subscription: payload,
                subscriptionsActionResponse: payload,
            }
        }

        case actions.UPDATE_SUBSCRIPTION_PAYMENT_FAILED: {
            return {
                ...state,
                updateSubPaymentInProgress: false,
                subscriptionsActionResponse: payload,
            }
        }

        case actions.SELECT_SUBSCRIPTION_CARD: {
            return {
                ...state,
                selectedSubscriptionCard: payload,
            }
        }

        case actions.GET_SUBSCRIPTION_RENEWALS: {
            return {
                ...state,
                getSubscriptionRenewalsInProgress: true,
            }
        }

        case actions.GET_SUBSCRIPTION_RENEWALS_SUCCESS: {
            return {
                ...state,
                getSubscriptionRenewalsInProgress: false,
                subscriptionRenewalsList: payload,
            }
        }

        case actions.GET_SUBSCRIPTION_RENEWALS_FAILED: {
            return {
                ...state,
                getSubscriptionRenewalsInProgress: false,
                subscriptionRenewalsList: [],
            }
        }

        case actions.CANCEL_SUBSCRIPTION: {
            return {
                ...state,
                cancelSubscriptionInProgress: true,
            }
        }

        case actions.CANCEL_SUBSCRIPTION_SUCCESS: {
            return {
                ...state,
                cancelSubscriptionInProgress: false,
                cancelSubscriptionResponse: payload,
                subscriptionsActionResponse: payload,
            }
        }

        case actions.CANCEL_SUBSCRIPTION_FAILED: {
            return {
                ...state,
                cancelSubscriptionInProgress: false,
                cancelSubscriptionResponse: payload,
                subscriptionsActionResponse: payload,
            }
        }

        case actions.GET_SUBSCRIPTION_PROMO_PRODUCTS: {
            return {
                ...state,
                gettingSubscriptionPromoProducts: true,
            }
        }

        case actions.GET_SUBSCRIPTION_PROMO_PRODUCTS_SUCCESS: {
            return {
                ...state,
                gettingSubscriptionPromoProducts: false,
                subscriptionPromoProducts: payload,
            }
        }

        case actions.GET_SUBSCRIPTION_PROMO_PRODUCTS_FAILED: {
            return {
                ...state,
                gettingSubscriptionPromoProducts: false,
            }
        }

        case actions.REACTIVATE_SUBSCRIPTION: {
            return {
                ...state,
                reactivateSubscriptionInProgress: true,
            }
        }

        case actions.REACTIVATE_SUBSCRIPTION_SUCCESS: {
            return {
                ...state,
                reactivateSubscriptionInProgress: false,
                subscription: payload,
                subscriptionsActionResponse: payload,
            }
        }

        case actions.REACTIVATE_SUBSCRIPTION_FAILED: {
            return {
                ...state,
                reactivateSubscriptionInProgress: false,
                subscriptionsActionResponse: payload,
            }
        }

        case actions.FAILED_SUBSCRIPTION_PAYMENT: {
            return {
                ...state,
                failedSubscriptionPayment: payload,
            }
        }

        case actions.CLEAR_ACTION_STATUS: {
            return {
                ...state,
                subscriptionsActionResponse: null,
            }
        }

        case actions.SET_SHOW_FAILED_SUBSCRIPTION_PAYMENT_MODAL: {
            return {
                ...state,
                showFailedSubscriptionPaymentModal: payload,
            }
        }

        case actions.SET_SHOW_DELETE_SUBSCRIPTION_CARD_MODAL: {
            return {
                ...state,
                showDeleteSubscriptionCardModal: payload,
                subscriptionsActionResponse: null,
            }
        }

        case actions.RESET_SUBSCRIPTIONS: {
            return initialState
        }

        default:
            return state
    }
}

export default subscription
